function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
    id: "failed_svg__a",
    d: "M0 .89h56.853v96.076H0z"
}), /*#__PURE__*/ React.createElement("path", {
    id: "failed_svg__c",
    d: "M.403 0h163.6v1H.403z"
}));
var _ref2 = /*#__PURE__*/ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
}, /*#__PURE__*/ React.createElement("g", {
    transform: "translate(23 19.402)"
}, /*#__PURE__*/ React.createElement("mask", {
    id: "failed_svg__b",
    fill: "#fff"
}, /*#__PURE__*/ React.createElement("use", {
    xlinkHref: "#failed_svg__a"
})), /*#__PURE__*/ React.createElement("path", {
    fill: "#E1EAFF",
    d: "M51.644 2.306L.39 92.545c-1.121 1.973.304 4.42 2.573 4.42h50.93a2.959 2.959 0 002.959-2.958V3.682c0-2.861-3.796-3.864-5.21-1.376",
    mask: "url(#failed_svg__b)"
})), /*#__PURE__*/ React.createElement("path", {
    stroke: "#3370FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M162.205 15.615l8.3-5.934m-6.785 14.391l9.948 1.525m-10.524-5.725l5.11-2.367"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#3370FF",
    d: "M56.284 115.902h37.281S72.7 36.76 58.232 50.178c0 0-8.514 2.367-5.37 39.296"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M56.284 115.902h37.281S72.7 36.76 58.232 50.178c0 0-8.514 2.367-5.37 39.296"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#FFF",
    d: "M83.598 64.014s3.314-31.377 4.82-33.802c3.584-5.773 3.178 8.427 1.671 8.346-2.286-.123 1.657-12.132 3.8-12.132 1.881 0 1.586 11.86-.324 11.715-1.813-.14 1.984-11.183 4.124-11.067 2.741.147-.409 19.113-.409 19.113s3.032 34.142.32 39.339c-2.713 5.198-15.709 3.77-14.002-21.511"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#126DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M83.598 64.014s3.314-31.377 4.82-33.802c3.584-5.773 3.178 8.427 1.671 8.346-2.286-.123 1.657-12.132 3.8-12.132 1.881 0 1.586 11.86-.324 11.715-1.813-.14 1.984-11.183 4.124-11.067 2.741.147-.409 19.113-.409 19.113s3.032 34.142.32 39.339c-2.713 5.198-15.709 3.77-14.002-21.511z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#FFF",
    d: "M86.332 24.994s-.071 8.867-1.253 13.018c-.15.521-2.36.364-3.476 1.274-1.118.91-1.144 2.883-3.021 3.625a18.117 18.117 0 01-6.647 1.28c-9.808 0-.626-18.57 0-19.197.626-.626 14.397 0 14.397 0"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#126DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M86.332 24.994s-.071 8.867-1.253 13.018c-.15.521-2.36.364-3.476 1.274-1.118.91-1.144 2.883-3.021 3.625a18.117 18.117 0 01-6.647 1.28c-9.808 0-.626-18.57 0-19.197.626-.626 14.397 0 14.397 0z"
}), /*#__PURE__*/ React.createElement("g", {
    transform: "translate(36 115.402)"
}, /*#__PURE__*/ React.createElement("mask", {
    id: "failed_svg__d",
    fill: "#fff"
}, /*#__PURE__*/ React.createElement("use", {
    xlinkHref: "#failed_svg__c"
})), /*#__PURE__*/ React.createElement("path", {
    stroke: "#3370FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.403.5h163.6",
    mask: "url(#failed_svg__d)"
})), /*#__PURE__*/ React.createElement("path", {
    fill: "#82A7FC",
    d: "M115.6 115.363c0-20.215 16.389-36.603 36.604-36.603s36.603 16.388 36.603 36.603"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#3370FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M193.053 115.363c0-20.215-16.388-36.603-36.604-36.603"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#B5CEFF",
    d: "M152.233 76.975l-29.91 5.864a4.3 4.3 0 01-5.044-3.39l-5.864-29.91a4.298 4.298 0 013.39-5.046l29.91-5.864a4.3 4.3 0 015.046 3.391l5.864 29.91a4.298 4.298 0 01-3.392 5.045"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M152.233 76.975l-29.91 5.864a4.3 4.3 0 01-5.044-3.39l-5.864-29.91a4.298 4.298 0 013.39-5.046l29.91-5.864a4.3 4.3 0 015.046 3.391l5.864 29.91a4.298 4.298 0 01-3.392 5.045z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#BACEFD",
    d: "M150.952 9.031l-18.868 16.455c-1.247 1.087-.85 3.116.716 3.652l23.685 8.113c1.565.536 3.123-.823 2.805-2.447l-4.817-24.567c-.318-1.623-2.274-2.293-3.521-1.206"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M150.952 9.031l-18.868 16.455c-1.247 1.087-.85 3.116.716 3.652l23.685 8.113c1.565.536 3.123-.823 2.805-2.447l-4.817-24.567c-.318-1.623-2.274-2.293-3.521-1.206z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#126DFF",
    d: "M81.602 71.873S68.248 40.852 57.675 47.459c-10.572 6.608 8.24 36.57 8.24 36.57l15.687-12.156z"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M81.602 71.873S68.248 40.852 57.675 47.459c-10.572 6.608 8.24 36.57 8.24 36.57l15.687-12.156z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#FFC60A",
    d: "M87.375 28.75c-2.523 2.943-13.285 2.017-13.285 2.017s-3.847-2.662-4.556 1.948c-.299 1.944 2.61 5.112 2.61 5.112s-1.949 8.381-10.435 8.242c-5.167-.085-8.137 4.452-7.72 9.668-.68 3-1.557 6.56-1.824 8.695-.958 7.651 0 19.127 0 19.127s-19.253-9.858-16.598-26.645c2.044-12.917 23.004-15.37 26.09-25.059C66.593 16.351 76.461 7.113 84.801 16.3c4.137 4.558 4.306 10.43 2.573 12.45"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#FFF",
    d: "M80.906 83.369s-13.77-44.747-11.268-45.614c.905-.313 2.735 1.158 4.566 3.188 3.24 3.59-1.948-3.968.916-4.428 1.021-.164 2.531 1.175 3.975 3.003 2.608 3.302-.93-2.165.74-3.028 1.67-.864 29.31 54.929 15.26 60.908-14.623 6.223-27.855-14.325-27.855-14.325l11.01-8.532 2.656 8.828z"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#126DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M80.906 83.369s-13.77-44.747-11.268-45.614c2.504-.867 12.103 11.941 9.182 12.423-2.922.482-6.564-13.203-3.7-13.663 2.865-.461 9.584 10.921 7.873 11.704-4.19 1.92-4.828-10.866-3.159-11.729 1.67-.864 29.311 54.929 15.261 60.908-14.623 6.223-27.855-14.325-27.855-14.325l11.01-8.532 2.656 8.828z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#FFF",
    d: "M71.837 51.546s-10.204-3.847-7.053 0c2.161 2.639 9.052 7.473 9.052 7.473l-1.999-7.473z"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#3370FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M71.837 51.546s-10.204-3.847-7.053 0c2.161 2.639 9.052 7.473 9.052 7.473l-1.999-7.473z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#3370FF",
    d: "M83.092 32.78a1.086 1.086 0 11-2.171 0 1.086 1.086 0 012.171 0"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#3370FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M183.453 38.701s-22.096 30.629-23.919 24.168c-2.592-9.181 26.747 2.282 45.305 20.689"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#F54A45",
    d: "M226.55 91.303c0 6.927-5.615 12.543-12.542 12.543s-12.543-5.616-12.543-12.543 5.616-12.543 12.543-12.543 12.543 5.616 12.543 12.543"
}), /*#__PURE__*/ React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M208.153 85.448l11.71 11.71m-.001-11.71l-11.709 11.71m-89.041-43.484l25.267-5.57M120.692 60.84l25.268-5.57m-23.53 13.453l12.633-2.785"
}));
function SvgFailed(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        width: 250,
        height: 125
    }, props), _ref, _ref2);
}
export default SvgFailed;
